const NUMBER_OF_MINUTES_IN_AN_HOUR = 60;
const NUMBER_OF_HOURS_IN_A_DAY = 24;
const NUMBER_OF_MINUTES_IN_A_DAY = 1440;
export class PolicyFormatter {
    constructor(translations) {
        this.translations = translations;
        this.getPolicyLimitByUnits = (limitInMinutes) => {
            const days = limitInMinutes / NUMBER_OF_MINUTES_IN_A_DAY;
            const hours = (days - Math.floor(days)) * NUMBER_OF_HOURS_IN_A_DAY;
            const minutes = limitInMinutes % NUMBER_OF_MINUTES_IN_AN_HOUR;
            return {
                days: Math.floor(days),
                hours: Math.floor(hours),
                minutes,
            };
        };
        this.getPolicyLimit = (limitInMinutes) => {
            const { days, hours, minutes } = this.getPolicyLimitByUnits(limitInMinutes);
            if (days) {
                return `${days} ${days === 1 ? this.translations.day : this.translations.days}`;
            }
            const formattedTime = [];
            if (hours) {
                formattedTime.push(`${hours} ${hours === 1 ? this.translations.hour : this.translations.hours}`);
            }
            if (minutes) {
                formattedTime.push(`${minutes} ${minutes === 1 ? this.translations.minute : this.translations.minutes}`);
            }
            if (formattedTime.length > 1) {
                return `${formattedTime[0]} ${this.translations.and} ${formattedTime[1]}`;
            }
            else {
                return formattedTime[0];
            }
        };
    }
}
//# sourceMappingURL=policy.formatter.js.map